import { createFileRoute } from '@tanstack/react-router';
import { Heading } from 'react-aria-components';
import Markdown from 'react-markdown';
import RootLayout from 'src/components/layout/RootLayout';
import { privacyMD } from 'src/components/PrivacyModal';
import useSkeletonCleanup from 'src/init/useSkeletonCleanup';

const PrivacyPage = () => {
  useSkeletonCleanup();

  return (
    <RootLayout className="h-full flex flex-col">
      <div className="w-full max-w-[47.5rem] mx-auto bg-surface-alt rounded-3xl shadow-3 p-11 flex-1 min-h-0 overflow-auto">
        <Heading
          level={1}
          className="text-surface-alt-90 text-2xl font-bold mb-6"
        >
          Privacy Policy
        </Heading>
        <Markdown className="markdown">{privacyMD}</Markdown>
      </div>
    </RootLayout>
  );
};

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
});
